var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-dialog',{attrs:{"value":_vm.dialog,"width":560,"title":_vm.title},on:{"input":val => { if (!val) _vm.hide() },"close":_vm.hide}},[(_vm.currentLink)?_c('div',{staticClass:"video-wrap"},[_c('youtube-iframe',{attrs:{"link":{ videoId: _vm.currentLink.videoId },"height":"100%"}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }